import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  // mode: 'history',  //去掉url中的#
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/view/login/login"], resolve)
    },
    {
      path: "/dataCenterDecision",
      name: "dataCenterDecision",
      component: () => import("@/view/dataCenter/dataCenterDecision")
    },
    {
      path: "/dataCenter",
      name: "dataCenter",
      component: () => import("@/view/dataCenter/index")
    },
    {
      path: "/index",
      name: "index",
      component: () => import("@/view/index/index"),
      children: [
        {
          path: "nongwu_warn",
          name: "nongwu_warn",
          meta: {
            keepAlive: true
          },
          component: () => import("@/view/nongwu_warn")
        },
        {
          path: "backlogList",
          name: "backlogList",
          component: resolve => require(["@/view/backlog/backlogList"], resolve)
        },
        {
          path: "illegalInformation",
          name: "illegalInformation",
          component: resolve =>
            require(["@/view/backlog/illegalInformation"], resolve)
        },
        {
          path: "backlogTask",
          name: "backlogTask",
          component: resolve => require(["@/view/backlog/backlogTask"], resolve)
        },
        {
          path: "timeCondition",
          name: "timeCondition",
          component: resolve =>
            require(["@/view/backlog/timeCondition"], resolve)
        },
        {
          path: "missionWrite",
          name: "missionWrite",
          component: resolve =>
            require(["@/view/backlog/missionWrite"], resolve)
        },
        {
          path: "/actually",
          name: "actually",
          component: () => import("@/view/actually/actually"),
          children: [
            {
              path: "shikuang",
              name: "shikuang",
              component: () => import("@/view/actually/shikuang/index"),
              children: [
                {
                  path: "waterAndElectricity",
                  name: "waterAndElectricity",
                  // meta:{
                  //   detail: true
                  // },
                  component: () =>
                    import(
                      "@/view/actually/waterAndElectricity/waterAndElectricity"
                    )
                },
                {
                  path: "detector",
                  name: "detector",
                  // meta:{
                  //   detail: true
                  // },
                  component: () => import("@/view/actually/detector/detector")
                },
                {
                  path: "switchState",
                  name: "switchState",
                  meta:{
                    detail: true
                  },
                  component: () =>
                    import("@/view/actually/switchState/switchState")
                },
                {
                  path: "dataStatistics",
                  name: "dataStatistics",
                  meta:{
                    detail: true
                  },
                  component: () =>
                    import("@/view/actually/dataStatistics/dataStatistics")
                },
                {
                  path: "feiqishuju",
                  name: "feiqishuju",
                  meta:{
                    detail: true
                  },
                  component: () => import("@/view/actually/feiqishuju")
                }
              ]
            },
            {
              path: "/scene",
              name: "scene",
              component: () => import("@/view/actually/scene/scene"),
              children: [
                {
                  path: "realTimeData",
                  name: "realTimeData",
                  meta:{
                    // keepAlive: true,
                    detail: true
                  },
                  component: () =>
                    import("@/view/actually/realTimeData/realTimeData")
                },
                {
                  path: "feiqishikuang",
                  name: "feiqishikuang",
                  meta:{
                    // keepAlive: true,
                    detail: true
                  },
                  component: () => import("@/view/actually/feiqishikuang")
                },
                {
                  path: "videoMonitoring",
                  name: "videoMonitoring",
                  meta:{
                    detail: true
                  },
                  component: () =>
                    import("@/view/actually/videoMonitoring/videoMonitoring")
                },
                {
                  path: "dataIllegalWarning",
                  name: "dataIllegalWarning",
                  meta:{
                    keepAlive: true,
                    detail: true
                  },
                  component: () =>
                    import(
                      "@/view/actually/dataIllegalWarning/dataIllegalWarning"
                    )
                },
                {
                  path: "water_power_table",
                  name: "water_power_table",
                  meta:{
                    detail: true
                  },
                  component: () => import("@/view/actually/water_power_table")
                }
              ]
            },
            {
              path: "switchStateDetail",
              name: "switchStateDetail",
              meta:{
                detail: true
              },
              component: () =>
                import("@/view/actually/switchState/switchStateDetail")
            }
          ]
        },
        {
          path: "workbench",
          name: "workbench",
          component: () => import("@/view/workbench/workbench")
        },
        {
          path: "company_warn",
          name: "company_warn",
          meta: {
            keepAlive: true
          },
          component: () => import("@/view/company_warn")
        },
        // 旧企业预警列表
        // {
        //   path: "illegalWarning",
        //   name: "illegalWarning",
        //   component: () => import("@/view/illegalWarning/illegalWarning")
        // },
        {
          path: "management",
          name: "management",
          meta: {
            keepAlive: true
          },
          component: resolve =>
            require(["@/view/management/management"], resolve)
        },
        {
          path: "supervision",
          name: "supervision",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/management/supervision"], resolve)
        },
        {
          path: "notSupervision",
          name: "notSupervision",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/management/notSupervision"], resolve)
        },
        {
          path: "notSupervisionDetails",
          name: "notSupervisionDetails",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/management/notSupervisionDetails"], resolve)
        },
        {
          path: "manager",
          name: "manager",
          meta:{
            detail: true
          },
          component: resolve => require(["@/view/management/manager"], resolve)
        },
        {
          path: "floatingRate",
          name: "floatingRate",
          component: resolve =>
            require(["@/view/management/floatingRate"], resolve)
        },
        {
          path: "userResponse",
          name: "userResponse",
          component: resolve =>
            require(["@/view/userResponse/userResponse"], resolve)
        },
        {
          path: "discharge",
          name: "discharge",
          component: resolve => require(["@/view/discharge/discharge"], resolve)
        },
        {
          path: "concentration",
          name: "concentration",
          component: resolve =>
            require(["@/view/concentration/concentration"], resolve)
        },
        {
          path: "nongwupaishui",
          name: "nongwupaishui",
          component: resolve => require(["@/view/nongwupaishui"], resolve)
        },
        {
          path: "production_date_manage",
          name: "production_date_manage",
          component: () => import("@/view/production_date_manage")
        },
        // {
        //   path: 'floatingRate',
        //   name: 'floatingRate',
        //   component: resolve => require(['@/view/floatingRate/floatingRate'], resolve)
        // },
        {
          path: "basinMsg",
          name: "basinMsg",
          meta: {
            keepAlive: true
          },
          component: resolve => require(["@/view/basinMsg/basinMsg"], resolve)
        },
        {
          path: "basinMsgDetail",
          name: "basinMsgDetail",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/basinMsg/basinMsgDetail"], resolve)
        },
        {
          path: "basinMsgRelation",
          name: "basinMsgRelation",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/basinMsg/basinMsgRelation"], resolve)
        },
        {
          path: "basinMsgAdd",
          name: "basinMsgAdd",
          component: resolve =>
            require(["@/view/basinMsg/basinMsgAdd"], resolve)
        },
        {
          path: "personalCenter",
          name: "personalCenter",
          component: resolve =>
            require(["@/view/personalCenter/personalCenter"], resolve)
        },
        {
          path: "bloggers",
          name: "bloggers",
          meta: {
            keepAlive: true
          },
          component: () => import("@/view/bloggers/bloggers")
        },
        {
          path: "nongwu_list",
          name: "nongwu_list",
          meta: {
            keepAlive: true
          },
          component: () => import("@/view/nongwu_list")
        },
        {
          path: "historyWarningDetails",
          name: "historyWarningDetails",
          meta:{
            detail: true
          },
          component: resolve =>
            require([
              "@/view/actually/dataIllegalWarning/historyWarningDetails"
            ], resolve)
        },
        {
          path: "warningTypeDetail",
          name: "warningTypeDetail",
          meta:{
            detail: true
          },
          component: resolve =>
            require([
              "@/view/actually/dataIllegalWarning/warningTypeDetail"
            ], resolve)
        },
        {
          path: "rightManagement",
          name: "rightManagement",
          meta: {
            keepAlive: true
          },
          component: resolve =>
            require(["@/view/rightManagement/rightManagement"], resolve)
        },
        {
          path: "userPersonal",
          name: "userPersonal",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/rightManagement/userPersonal"], resolve)
        },
        {
          path: "userChange",
          name: "userChange",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/rightManagement/userChange"], resolve)
        },
        {
          path: "RightsProfile",
          name: "RightsProfile",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/rightManagement/RightsProfile"], resolve)
        },
        {
          path: "addMember",
          name: "addMember",
          component: resolve =>
            require(["@/view/rightManagement/addMember"], resolve)
        },
        {
          path: "nextMember",
          name: "nextMember",
          component: resolve =>
            require(["@/view/rightManagement/nextMember"], resolve)
        },
        {
          path: "regionManagement",
          name: "regionManagement",
          component: resolve =>
            require(["@/view/rightManagement/regionManagement"], resolve)
        },
        {
          path: "companyManagement",
          name: "companyManagement",
          meta:{
            detail: true
          },
          component: resolve =>
            require(["@/view/rightManagement/companyManagement"], resolve)
        },
        {
          path: "leninstatistics",
          name: "leninstatistics",
          component: resolve =>
            require(["@/view/leninstatistics/leninstatistics"], resolve)
        },
        {
          path: "historyWarning",
          name: "historyWarning",
          meta: {
            keepAlive: true,
            detail: true
          },
          component: resolve =>
            require(["@/view/illegalWarning/historyWarning"], resolve)
        },
        {
          path: "situationReflect",
          name: "situationReflect",
          component: resolve =>
            require(["@/view/backlog/situationReflect"], resolve)
        },
        {
          path: "/statement",
          name: "statement",
          component: resolve =>
            require(["@/view/statement/statement"], resolve),
          children: [
            {
              path: "theEnvironmentalParameter",
              name: "theEnvironmentalParameter",
              meta:{
                detail: true
              },
              component: resolve =>
                require([
                  "@/view/statement/theEnvironmentalParameter/theEnvironmentalParameter"
                ], resolve)
            },
            {
              path: "statisticalInformation",
              name: "statisticalInformation",
              meta:{
                detail: true
              },
              component: resolve =>
                require([
                  "@/view/statement/statisticalInformation/statisticalInformation"
                ], resolve)
            },
            {
              path: "monthVouchers",
              name: "monthVouchers",
              meta:{
                detail: true
              },
              component: resolve =>
                require([
                  "@/view/statement/monthVouchers/monthVouchers"
                ], resolve)
            },
            ,
            {
              path: "monthVouchersDetail",
              name: "monthVouchersDetail",
              meta:{
                detail: true
              },
              meta:{
                detail: true
              },
              component: resolve =>
                require([
                  "@/view/statement/monthVouchers/monthVouchersDetail"
                ], resolve)
            },
            {
              path: "theEliminator",
              name: "theEliminator",
              component: resolve =>
                require([
                  "@/view/statement/theEliminator/theEliminator"
                ], resolve)
            },
            {
              path: "theEliminatorDetail",
              name: "theEliminatorDetail",
              meta:{
                detail: true
              },
              component: resolve =>
                require([
                  "@/view/statement/theEliminator/theEliminatorDetail"
                ], resolve)
            }
          ]
        },
        {
          path: "logRecord",
          name: "logRecord",
          component: resolve =>
            require([
              "@/view/logRecord/logRecord"
            ], resolve)
        }
      ]
    }
  ]
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    let jwt = localStorage.getItem("Authorization");
    if (jwt === "null" || jwt === "") {
      next("/login");
    } else {
      next();
    }
  }
  // 路由发生变化滚动条滑到顶部
  let noheadContentEle = document.getElementsByClassName("router-container")[0]
  if(noheadContentEle){
    noheadContentEle.scrollTop = 0
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js